module.exports = __webpack_public_path__ + "static/media/cpu.470a8cae.svg";